import {defineMessages} from 'react-intl';

export default defineMessages({
    loading: {
        id: 'app.components.toast.loading',
        defaultMessage: 'Loading...'
    },
    error: {
        id: 'app.components.toast.error',
        defaultMessage: 'Something went wrong. Please try again or contact us.'
    },
    success: {
        id: 'app.components.toast.success',
        defaultMessage: 'Done!'
    }
});
